import {addGenericErrorToast} from '@albert-io/atomic';
import {getStudentQuery} from 'client/Classrooms/StudentDashboard/StudentDashboard.queries.js';
import {useStudentDashboard} from 'client/Classrooms/StudentDashboard/StudentDashboard.store';

export default function useGetStudent() {
  const isStudentLoading = useStudentDashboard((state) => state.student === null);
  const setStudent = useStudentDashboard((state) => state.setStudent);
  const student = useStudentDashboard((state) => state.student);

  function fetchStudent() {
    getStudentQuery()
      .getResourcePromise()
      .then((fetchedStudent) => {
        setStudent(fetchedStudent);
      })
      .catch((error) => {
        console.error(error);
        addGenericErrorToast();
      });
  }

  return {fetchStudent, isStudentLoading, student};
}
